<script lang="ts" setup>
import { ref, computed } from 'vue'

import type { Props } from './types'

import AppIconsBar from '@/components/App/IconsBar/index.vue'

const props = defineProps<Props>()

const { t } = useI18n()
const emit = defineEmits(['selectedTypologyCode'])

const selectedTypologyCode = ref(props.currentTypologyCode)
const shortedTypologies = computed(() => [...props.typologies].sort((a, b) => a.min_area - b.min_area))

const scrollToTab = (typologyCode: string) => {
  if (selectedTypologyCode.value === typologyCode) return

  const tab = document.getElementById(`typology-tab-${typologyCode}`)

  if (tab) {
    tab.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' })
  }
}

const selecteTypology = (typologyCode: string) => {
  scrollToTab(typologyCode)

  selectedTypologyCode.value = typologyCode
  emit('selectedTypologyCode', typologyCode)
}
</script>

<script lang="ts">
export default {
  name: 'TypologySlider'
}
</script>

<template>
  <div class="typology-container w-full bg-white">
    <div class="typology-slider w-full">
      <AppSlider
        id="quotation-plan-typology-tabs-slider"
        show-buttons
        lateral-paddings="hidden"
        class="border-b-2 border-carbon-light-50">
        <ul class="typology-container__tabs-holder">
          <li
            v-for="typology in shortedTypologies"
            :id="`typology-tab-${typology.min_unit_code}`"
            :key="`typology-tab-${typology.min_unit_code}`"
            class="typology-container__tab"
            :class="{ '!border-brand-800': selectedTypologyCode === typology.min_unit_code }"
            :data-lh-id="`quotation-plan-typology-tab-selected-${type}`"
            @click="selecteTypology(typology.min_unit_code)">
            <p
              class="text-18 text-primary-600 font-medium pointer-events-none">
              {{ t('squareMeter', { area: typology.min_area}) }}
            </p>

            <AppIconsBar
              v-if="listingType !== 'Lote'"
              class="mt-10 pointer-events-none"
              :data="{
                bedroom: typology.bedroom,
                bathroom: typology.bathroom,
                parkingLots: typology.parking_numbers
              }"
              :hidden-elements="[0]" />
          </li>
        </ul>
      </AppSlider>
    </div>
  </div>
</template>

<style lang="scss">
.typology-container {
  &__tabs-holder {
    @apply flex gap-8 lg:gap-16;
  }

  &__tab {
    @apply px-14 py-14 border border-carbon-light-50 cursor-pointer hover:bg-carbon-light-50;

    border-radius: 13px;

    @media(min-width: theme('screens.md')) {
      @apply px-20 py-20;
    }

    @media(max-width: theme('screens.md')) {
      .icon-bar {
        &__icon {
          @apply w-16 h-16;
        }

        &__text {
          @apply text-12;
        }
      }
    }
  }

  & .app-slider {
    @apply border-b-0;

    &__button {
      @apply absolute;

      &--left {
        @apply left-0;
      }

      &--right {
        @apply right-0;
      }
    }
  }
}
</style>

<i18n src="./i18n.json" lang="json" />
